import { useState } from "react";
import client from "../api/client";

function ContactPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await client.post("/contact", { email, message });
      setSuccess(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main style={{ maxWidth: "520px", margin: "0 auto" }}>
      <h1>Contact Us</h1>
      <p style={{ opacity: 0.75, fontSize: "14px", marginBottom: "32px", lineHeight: "1.7" }}>
        Have feedback, a question, or just want to say hello? I'd love to hear from you.
      </p>

      {success ? (
        <div style={{
          background: "rgba(125, 211, 232, 0.07)",
          border: "1px solid rgba(125, 211, 232, 0.2)",
          borderRadius: "10px",
          padding: "24px",
          fontSize: "14px",
          lineHeight: "1.7"
        }}>
          💛 Thank you for reaching out. I'll get back to you soon.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>
            Your Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </label>

          <label>
            Message
            <textarea
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message here..."
              required
              style={{ marginTop: "6px" }}
            />
          </label>

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={isSubmitting} style={{ marginTop: "8px" }}>
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      )}
    </main>
  );
}

export default ContactPage;